import React from 'react';
import { useSelector } from "react-redux";
import {makeStyles} from "@mui/styles"
import { useDialogState } from "../../../hooks/useDialogState";
import { useAttributeState } from "../../../hooks/useAttributeState";

import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import RenderOnRole from "../../RenderOnRole";

// Bearbeiten-Fenster der Attribute des gewählten Bauteils

const useStyles = makeStyles(() => ({
  treeView: {
    textAlign: "left",
  },
  attrEdit: {
    minHeight: "40vh",
    maxHeight: "45vH",
    width: "80%",
    overflowY: "scroll",
    overflowX: "hidden",
    margin: "15px",
    padding: "20px",
    float: "right",
    border: "1px solid #4D6F8C",
    borderRadius: "10px",
  },
  ueberAttr: {
    float: "left",
    textAlign: "left",
    fontSize: "16px",
    fontWeight: "bold",
    width: "100%",
  },
  attrEditBtn: {
    float: "right",
    textAlign: "right",
  },
  attrMeta: {
    textAlign: "left",
    marginLeft: "5px",
  },
  lightIcons: {
    color: "grey",
  },
  darkIcons: {
    color: "#e5e5e5",
  },
}));

// Darstellung der Enumeratoren, sofern vorhanden
function DisplayEnumsTree({ enums }) {
  const classes = useStyles();

  if (enums !== null) {
    return (
      <SimpleTreeView
            className={classes.treeView}
            slots={{ collapseIcon: ExpandMoreIcon, expandIcon: ChevronRightIcon, endIcon: ArrowRightIcon }}
            key={1}
        >
        {DisplayEnumsItem(enums)}
      </SimpleTreeView>
    );
  } else {
    return " ";
  }
}

// Enum-Item mapping
const DisplayEnumsItem = (enums) =>
    enums?.map((item) => (
        <TreeItem
            key={String(item.value)}
            itemId={String(item.value)}
            label={item.text}
        />
    ));

function EditAttr() {
  const classes = useStyles();
  const attribute = useAttributeState();
  const dialog = useDialogState();
  const SiteColor = useSelector((state) => state.siteColor);
  const AttrSelected = attribute.selected;

  return (
    <div className={classes.attrEdit}>
      <div className={classes.ueberAttr}>{AttrSelected.name}</div>
      <RenderOnRole roles={['MAP_ADMIN', 'ADMIN_MAP', 'TWIN_DATA_ADMIN']}>
      {AttrSelected.twin_only ? SiteColor ? (
        <div className={classes.attrEditBtn}>
          <IconButton
            className={classes.lightIcons}
            onClick={() => dialog.setDeleteAttrOpen(true)}
          >
            <DeleteIcon />
          </IconButton>
        </div>
      ) : (
        <div className={classes.attrEditBtn}>
          <IconButton
            className={classes.darkIcons}
            onClick={() => dialog.setDeleteAttrOpen(true)}
          >
            <DeleteIcon />
          </IconButton>
        </div>
      ) : null }
      </RenderOnRole>
      <div>
        <div className={classes.attrMeta}>
          Merkmal-ID: {AttrSelected.guid}
        </div>
        <div className={classes.attrMeta}>
          System Name: {AttrSelected.system_name}
        </div>
        <div className={classes.attrMeta}>
          Beschreibung: {AttrSelected.description}
        </div>
        <div className={classes.attrMeta}>
          Definition: {AttrSelected.definition}
        </div>
        <div className={classes.attrMeta}>
          Einheit: {AttrSelected.unit}
        </div>
        <div className={classes.attrMeta}>
          Enumeratoren: <DisplayEnumsTree enums={AttrSelected.enumeratorValues} />
        </div>
        <div className={classes.attrMeta}>
          Daten-Typ: {AttrSelected.data_type}
        </div>
        <div className={classes.attrMeta}>
          Property-Status: {AttrSelected.property_status}
        </div>
        <div className={classes.attrMeta}>
          Property-URI: {AttrSelected.property_uri}
        </div>
      </div>
    </div>
  );
}

export default EditAttr;
